import { tw } from "@careinfo/tailwind";
import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { useForm, UseFormSetError } from "react-hook-form";
import { createCustomerValidationForm } from "../../utils/validationSchemas";
import Button from "../Reusable/Button";
import CustomerForm from "./CustomerForm";
import Control from "react-select/dist/declarations/src/components/Control";

interface Props {
  handleCreate: (data: any, setError: UseFormSetError<any>) => void;
  isLoading: boolean;
}

const CreateCustomer = (props: Props) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    setValue,
    control,
    clearErrors,
  } = useForm<any>({
    resolver: yupResolver(createCustomerValidationForm),
  });

  const { handleCreate, isLoading } = props;

  return (
    <form
      onSubmit={handleSubmit((data: any) => handleCreate(data, setError))}
      autoComplete="off"
    >
      <CustomerForm
        clearErrors={clearErrors}
        errors={errors}
        register={register}
        setValue={setValue}
        control={control}
      />
      <div className={tw`flex justify-end w-full`}>
        <div className={tw`w-[100px] mr-4`}>
          <Button label={"Create"} isLoading={isLoading} />
        </div>
      </div>
    </form>
  );
};

export default CreateCustomer;
